import { createContext, useContext } from "react";
import type {
  PortalNotice,
  ResolvedPortalTheme,
} from "@shared-core/data/customer-api-types";

/**
 * The theme the signed-in person sees at the customer they are working as, read once by the portal layout
 * (docs/features/portal-theme). The server resolved it; the portal only applies it.
 */
export interface PortalThemeForViewer {
  /** The read is still on its way (the staff view renders before it answers; the portal waits for it). */
  isLoading: boolean;
  /** Null when there is no theme to apply (the read failed, or the feature is off): the Pollards look. */
  theme: ResolvedPortalTheme | null;
  /** The notices showing today, newest first. */
  notices: PortalNotice[];
  /** Closes a pop-up: for this visit at once, and for good where the read named a dismiss URL. */
  dismissNotice(notice: PortalNotice): void;
}

export const PortalThemeContext = createContext<PortalThemeForViewer | null>(
  null,
);

/** The portal's theme, or null outside the portal layout (a page rendered on its own, in a story or the staff view). */
export function usePortalTheme(): PortalThemeForViewer | null {
  return useContext(PortalThemeContext);
}
